function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 512,
  height: 512
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M466.7,107.9c-0.7-2.5-2.7-4.3-5.2-4.9l-42.9-9.7l-9.7-42.9c-0.8-3.8-4.6-6.1-8.4-5.3 c-1.3,0.3-2.5,0.9-3.4,1.9l-49.3,49.3c-94.4-57-217.1-26.6-274.1,67.8c-57,94.4-26.6,217.1,67.8,274.1 c94.4,57,217.1,26.6,274.1-67.8c38.3-63.4,38.3-142.8,0-206.3l49.4-49.4C466.8,113,467.4,110.4,466.7,107.9 M430.3,267.3 c0,102.5-83.1,185.6-185.6,185.6c-102.5,0-185.6-83.1-185.6-185.6c0-102.5,83.1-185.6,185.6-185.6c32.6,0,64.7,8.6,92.9,24.9 l-22.7,22.7c-0.2,0.2-0.4,0.5-0.5,0.7c-75.9-38.7-168.8-8.4-207.5,67.5s-8.4,168.8,67.5,207.5s168.8,8.4,207.5-67.5 c22.4-43.9,22.4-95.8,0.1-139.8c0.3-0.2,0.5-0.4,0.7-0.6l22.7-22.7C421.7,202.6,430.3,234.7,430.3,267.3 M365.4,196.5 c39,66.6,16.7,152.3-50,191.4c-66.6,39-152.3,16.7-191.4-50c-39-66.6-16.7-152.3,50-191.4c43.7-25.6,97.8-25.6,141.5,0.1l7.4,32.7 l-7.1,7.1c-44.9-39.4-113.2-35-152.6,9.9c-39.4,44.9-35,113.2,9.9,152.6c44.9,39.4,113.2,35,152.6-9.9 c35.8-40.8,35.8-101.9,0-142.7l7.1-7.1L365.4,196.5z M274.8,267.3c0.1,16.7-13.4,30.3-30.1,30.3s-30.3-13.4-30.3-30.1 c-0.1-16.7,13.4-30.3,30.1-30.3c5.6,0,11.1,1.5,15.9,4.5l-20.7,20.7c-2.8,2.7-2.9,7.1-0.2,9.9c2.7,2.8,7.1,2.9,9.9,0.2 c0.1-0.1,0.1-0.1,0.2-0.2l20.7-20.7C273.2,256.3,274.8,261.8,274.8,267.3 M270.4,231.7c-19.8-14.3-47.5-9.9-61.8,9.9 c-14.3,19.8-9.9,47.5,9.9,61.8c19.8,14.3,47.5,9.9,61.8-9.9c11.2-15.5,11.2-36.4,0-51.9l35.4-35.4c33.9,39.4,29.4,98.7-9.9,132.6 c-39.4,33.9-98.7,29.4-132.6-9.9c-33.9-39.4-29.4-98.7,9.9-132.6c35.3-30.4,87.5-30.4,122.7,0L270.4,231.7z M401.8,158.1 l-26.3,26.3l-3.9-0.9l-0.2,0l-35.1-7.9l-8.8-39.1l70.5-70.5l7.9,34.8c0.6,2.6,2.7,4.7,5.3,5.3l34.8,7.9L401.8,158.1z"
});

var SvgAuMissao = function SvgAuMissao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuMissao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/au-missao.897d6708.svg";
export { ForwardRef as ReactComponent };